import * as React from 'react';
import './radiobutton.less';

// [COMPONENT USAGE]

// export interface State {
// 	selectedRadio: string;
// }

/* 
<div className="ds-form-radio-horizontal"> or ds-form-radio-vertical
<RadioButton
	onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
		this.handleRadioChange(e);
	}}
	isChecked={this.state.selectedRadio === 'Test' ? true : false}
	id={CoreHelper.guid()}
	value="Test"
	labelText="Test"
></RadioButton>; 

<RadioButton
	onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
		this.handleRadioChange(e);
	}}
	isChecked={this.state.selectedRadio === 'Test2' ? true : false}
	id={CoreHelper.guid()}
	value="Test2"
	labelText="Test2"
></RadioButton>; 

</div>
*/

// private readonly handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
// 	this.setState({
// 		selectedRadio: event.target.value,
// 	});
// };

// You can pass a popup as a render prop to radio button like so :
// popup={(): React.ReactNode => (
// 	<Popup
// 		trigger={<img src={theme.image.tooltipIcon} alt="" />}  trigger is the visual element which will trigger the popup
// 		content={t<string>('popups.profileAccess.signer')} the message it self
// 		position="bottom left"  the position of the text
// 	/>
// )}

export interface RadioButtonProps {
	/**sets a unique identifier for the radio button */
	id: string;
	/**controls the state of the radio button */
	isChecked?: boolean;
	/**controls if the radio button is disabled or not */
	isDisabled?: boolean;
	/**sets the text of the label */
	labelText: string;
	/**sets a value to the radio button */
	value: string;
	/**sets an error to the radio button */
	hasError?: boolean;
	/**sets an error message to the radio button */
	errorMessage?: string;
	/** Set the event that should be handle when checkbox is clicked */
	onChange?(event: any): void;
	/**sets a popup */
	tooltip?: () => React.ReactNode;
}

export interface RadioButtonState {
	internalChecked: boolean;
}

export class RadioButton extends React.Component<RadioButtonProps, RadioButtonState> {
	constructor(props: RadioButtonProps) {
		super(props);

		this.state = {
			internalChecked: this.props.isChecked || false,
		};
	}

	// componentDidUpdate(prevProps: RadioButtonProps): void {
	// 	const { isChecked } = this.props;
	// 	const { isChecked: oldChecked } = prevProps;
	// 	const { internalChecked } = this.state;

	// 	if (isChecked !== oldChecked && isChecked !== internalChecked) {
	// 		// this.setState({
	// 		// 	...this.state,
	// 		// 	internalChecked: isChecked || false,
	// 		// });
	// 	}
	// }

	render(): JSX.Element {
		const { labelText, isChecked, id, value, onChange, errorMessage, hasError, tooltip, isDisabled } = this.props;
		// const { internalChecked } = this.state;

		return (
			<div className={`it-radio${isDisabled === true ? ' disabled' : ''}`}>
				<div className="radio-container">
					<span className="input-container">
						<input
							type="radio"
							className="radio-input"
							id={id}
							value={value}
							disabled={isDisabled}
							checked={isChecked}
							onChange={
								!isDisabled
									? (event: any): void => {
											// this.setState({ internalChecked: !internalChecked });
											onChange && onChange(event);
									  }
									: undefined
							}
						/>
						<span className="radio-icon"></span>
					</span>
					{labelText && (
						<label
							htmlFor={id}
							className="radio-label"
							onClick={
								!isDisabled
									? (event: any): void => {
											// this.setState({ internalChecked: !internalChecked });
											onChange && onChange(event);
									  }
									: undefined
							}
						>
							{labelText}
						</label>
					)}
					{tooltip && <span className="tooltip-icon">{tooltip()}</span>}
				</div>
				{hasError && (
					<div className="input-error-text radio-error-text">
						<span>{`${hasError ? errorMessage : ''}`}</span>
					</div>
				)}
			</div>
		);
	}
}

// export const RadioButton = (props: RadioButtonProps): JSX.Element => {
// 	const { labelText, isChecked, id, isDisabled, value, onChange, errorMessage, hasError, tooltip } = props;

// 	return (
// 		<>
// 			<div className="ds-radio-flex">
// 				<div>
// 					<label htmlFor={id} className="ds-radio-label">
// 						<input
// 							onChange={onChange}
// 							id={id}
// 							value={value}
// 							type="radio"
// 							className="ds-radiobutton"
// 							disabled={isDisabled}
// 							checked={isChecked}
// 						/>
// 						{labelText}
// 					</label>
// 					{tooltip && tooltip()}
// 				</div>

// 				{hasError && (
// 					<div className="ds-radio-error-text">
// 						<span>{`${hasError ? errorMessage : ''}`}</span>
// 					</div>
// 				)}
// 			</div>
// 		</>
// 	);
// };
